// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gq-a";
export var fulfillmentFormRail = "_gq-9";
export var headerTitleRow = "_gq-c";
export var orderDetailsWrapper = "_gq-7";
export var orderLinkTrigger = "_gq-2";
export var paymentInformationGrid = "_gq-h";
export var paymentSummaryColumn = "_gq-i";
export var shipmentContainer = "_gq-b";
export var shipmentDetailsMainPane = "_gq-8";
export var shipmentNavigationCard = "_gq-5";
export var shipmentNavigationRail = "_gq-3";
export var shipmentNavigationRailHeader = "_gq-4";
export var shipmentSummaryFact = "_gq-e";
export var shipmentSummaryGrid = "_gq-d";
export var shipmentSummaryMetadataRow = "_gq-f";
export var shipmentSummaryTags = "_gq-g";
export var shipmentWorkspace = "_gq-0";
export var shipmentWorkspaceContent = "_gq-6";
export var shipmentWorkspaceHeader = "_gq-1";